<template>
  <progress
    class="progress-bar"
    v-if="shouldShowProgressBar" :value="percentage" max="100"
  >
  </progress>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    alwaysShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    shouldShowProgressBar() {
      return this.percentage > 0 || this.alwaysShow;
    },
  },
};
</script>
<style lang="stylus" scoped>
  @require '../style/colors'

  progress {
    -webkit-appearance: none;
    background-color: $color-gray-200
    border-radius: 0.25rem
    height: 2.5rem
    width: 100%
  }

  ::-webkit-progress-bar
    background-color: #FFE5D9

  ::-webkit-progress-inner-element
    border: 2px solid #C0C4D0

  ::-webkit-progress-value
    background-color: #FF5500

</style>
